import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFileIcon = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M13.75 16.4688C13.9844 16.4688 14.2188 16.2637 14.2188 16V7.5625H11.875C11.3477 7.5625 10.9375 7.15234 10.9375 6.625V4.28125H6.25C5.98633 4.28125 5.78125 4.51562 5.78125 4.75V16C5.78125 16.2637 5.98633 16.4688 6.25 16.4688H13.75ZM4.375 4.75C4.375 3.72461 5.19531 2.875 6.25 2.875H11.084C11.582 2.875 12.0508 3.08008 12.4023 3.43164L15.0684 6.09766C15.4199 6.44922 15.625 6.91797 15.625 7.41602V16C15.625 17.0547 14.7754 17.875 13.75 17.875H6.25C5.19531 17.875 4.375 17.0547 4.375 16V4.75Z"
	})
});
const ForwardRef = forwardRef(SvgFileIcon);
export default ForwardRef;
